export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Kotak Mahindra Bank Home Loan EMI Calculator: Simplify Your Loan Planning",
    subHeading:
      "Understanding and planning your home loan EMI is critical to managing your finances efficiently. With <strong>MinEMI’s Home Loan EMI Calculator</strong>, you can simulate your monthly payments, compare different loan scenarios, and make informed decisions. Whether you’re taking a new home loan or transferring an existing one, this page is your guide to effective EMI management for <strong>Kotak Mahindra Bank Home Loans</strong>.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
